import { IRootStore, useStore } from 'saladsoft-primitive';
import { ILocalStore } from './LocalRootStore';

const useStoreWrapper = () => {
  return useStore<IRootStore & ILocalStore>();
};

export { useStoreWrapper };
